import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

// Lynn & Liana Designs — Reorder campaign (adc_v9j58cdpza).
// CAMPAIGN_PERIODS attributes no first-year value to reorder, so sales come from
// TOTAL_LOCAL_POST_DISCOUNT. `monthlyBudgetDollars` is the shared $3,000 pool.
//
// The better half of this program: a third of the spend returning more booked
// sales than the new-customer campaign, at 12.4x against its 6.8x.
export const campLlReorder: FaireAdCampaignEntity = {
  token: "camp_ll_reorder",
  type: "adCampaign",
  advertiserProfileToken: "adv_lynn_liana",
  segment: "REORDER_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 3000,
  startedRunningAt: "2026-07-14",
  segmentMetrics: {
    numReorderConversions: 99,
    salesDollars: 63551,
    totalAdsSpendDollars: 5124,
    returnOnAdSpend: 12.4,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-23T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
